export { default } from './shopping-cart-2'
